import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { Markdown } from '~components/Markdown';
import { NextImage } from '~components/NextImage/NextImage';
import { NextImageMods } from '~components/NextImage/NextImage.types';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';
import { FormRequest } from '~containers/Forms/FormRequest/FormRequest';

import { ContentBlockFormProps } from './ContentBlockForm.types';
import styles from './ContentBlockFrom.module.scss';

export function ContentBlockForm({
  title,
  text,
  image,
  ...sectionProps
}: ContentBlockFormProps) {
  return (
    <ContentBlockWrapper {...sectionProps} className={styles.wrapper}>
      <div className={styles.head}>
        <div className={styles.content}>
          <Typography
            tagName={TypographySizes.h2}
            mods={[TypographyMods.titleL]}
          >
            {title}
          </Typography>
          <Typography
            mods={[TypographyMods.bodyM]}
            tagName={TypographySizes.div}
          >
            <Markdown className={styles.text}>{text}</Markdown>
          </Typography>
        </div>
        {image && (
          <NextImage
            className={styles.media}
            {...image}
            mods={[NextImageMods.FitContain]}
          />
        )}
      </div>
      <FormRequest />
    </ContentBlockWrapper>
  );
}
